export default __webpack_public_path__ + "static/media/01-selfie.f2ed1c17.mp4";